module.exports = __webpack_public_path__ + "img/logo-08.1ecc3696.svg";